module.exports = "/React/dist/f2a8680c5016eb895d4cb1fc1598ef3d.png";